module.exports = {
  inputFile: './index.pffe',
  outputFile: 'dist/pffe.peggy',
  extensions: ['.pffe'],
  filter: [],
  plugin: [],
  treeshake: true
};
